import { ModalCloseButton as Base, ModalCloseButtonProps } from '@chakra-ui/react'
import React from 'react'

export const ModalCloseButton = (props: ModalCloseButtonProps) => (
  <Base borderRadius="full" bg="blackAlpha.100" color="gray.600" {...props} />
)
